import type { IqeProjectStatus } from '../interfaces/ui';

export const isCreateInProgress = (status: IqeProjectStatus) =>
  status === 'SUBMITTED' || status === 'PROCESSING';

export const isCreateSuccessful = (status: IqeProjectStatus) =>
  status === 'SUCCESSFUL';

export const isRunLogsDownloadEligible = (status: string) =>
  status === 'SUCCESSFUL';

export const isCreateFailed = (status: IqeProjectStatus) => status === 'FAILED';

export const isCreateLoginFailed = (status: IqeProjectStatus) =>
  status === 'FAILED_LOGIN';

export const isGenerateInProgress = (status: IqeProjectStatus) =>
  status === 'GENERATING';

export const isGenerateSuccessful = (status: IqeProjectStatus) =>
  status === 'GENERATE_SUCCESSFUL';

export const isGenerateFailed = (status: IqeProjectStatus) =>
  status === 'GENERATE_FAILED';

export const isGenerateStopping = (status: IqeProjectStatus) =>
  status === 'GENERATE_STOPPING';

export const isGenerateStopped = (status: IqeProjectStatus) =>
  status === 'GENERATE_STOPPED';

export const isExecuteInProgress = (status: IqeProjectStatus) =>
  status === 'EXECUTING';

export const isExecuteSuccessful = (status: IqeProjectStatus) =>
  status === 'EXECUTE_SUCCESSFUL';

export const isExecuteFailed = (status: IqeProjectStatus) =>
  status === 'EXECUTE_FAILED';

export const isExecuteStopping = (status: IqeProjectStatus) =>
  status === 'EXECUTE_STOPPING';

export const isExecuteStopped = (status: IqeProjectStatus) =>
  status === 'EXECUTE_STOPPED';

export const isEnhanceInProgress = (status: IqeProjectStatus) =>
  status === 'ENHANCING';

export const isEnhanceSuccessful = (status: IqeProjectStatus) =>
  status === 'ENHANCE_SUCCESSFUL';

export const isEnhanceFailed = (status: IqeProjectStatus) =>
  status === 'ENHANCE_FAILED';

export const isEnhanceStopping = (status: IqeProjectStatus) =>
  status === 'ENHANCE_STOPPING';

export const isEnhanceStopped = (status: IqeProjectStatus) =>
  status === 'ENHANCE_STOPPED';

export const isProjectOperationInProgress = (status: IqeProjectStatus) =>
  isGenerateInProgress(status) ||
  isExecuteInProgress(status) ||
  isEnhanceInProgress(status);

export const isProjectOperationSuccessful = (status: IqeProjectStatus) =>
  isGenerateSuccessful(status) ||
  isExecuteSuccessful(status) ||
  isEnhanceSuccessful(status);

export const isProjectOperationStopping = (status: IqeProjectStatus) =>
  isGenerateStopping(status) ||
  isExecuteStopping(status) ||
  isEnhanceStopping(status);

// Terminal stop confirmation (raw *_STOPPED_SUCCESSFUL) - unlocks Generate/Execute/Enhance
export const isProjectOperationStopped = (status: IqeProjectStatus) =>
  isGenerateStopped(status) ||
  isExecuteStopped(status) ||
  isEnhanceStopped(status);

export const isProjectTerminalFailure = (status: IqeProjectStatus) =>
  isCreateFailed(status) ||
  isCreateLoginFailed(status) ||
  isGenerateFailed(status) ||
  isExecuteFailed(status) ||
  isEnhanceFailed(status);

export const isGenerateOrEnhanceInProgress = (status: IqeProjectStatus) =>
  isGenerateInProgress(status) || isEnhanceInProgress(status);

// export const isCreateOrProjectOperationInProgress = (
//   status: IqeProjectStatus,
// ) => isCreateInProgress(status) || isProjectOperationInProgress(status);
